import type {CopilotChatReference} from '@github-ui/copilot-chat-types'

const isCustomCopilotRef = (ref: CopilotChatReference) => 'refOrigin' in ref && ref.refOrigin === 'custom_copilot'

const isCustomInstructionsRef = (ref: CopilotChatReference) => 'type' in ref && ref.type === 'custom-instructions'

export function filterOutCustomCopilotReferences(
  references: CopilotChatReference[] | null,
): CopilotChatReference[] | null {
  if (!Array.isArray(references)) return references

  return references.filter(ref => !isCustomCopilotRef(ref) && !isCustomInstructionsRef(ref))
}
